// extracted by mini-css-extract-plugin
module.exports = {"root":"Button-root-3V2xY"};